import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {ErrorMessage} from 'shells/form/error-message';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';

type Props = {
    doesAgree: boolean;
    onUpdateField: (value: boolean) => void;
};

export function AgreementCheckbox(props: Props) {
    const {doesAgree, onUpdateField} = props;

    const agreeLabel = (
        <span>
            I agree to Nutshell’s&nbsp;
            <Link
                href='https://support.nutshell.com/en/articles/8428992-terms-conditions-nutshell-license-agreement'
                newTab={true}
                className='underline'
            >
                license agreement&nbsp;
            </Link>
            and&nbsp;
            <Link
                href='https://support.nutshell.com/en/articles/8428993-terms-conditions-nutshell-s-privacy-policy'
                newTab={true}
                className='underline'
            >
                privacy policy
            </Link>
            .
        </span>
    );

    return (
        <StackLegacy spacing={4}>
            <Checkbox
                // @ts-expect-error
                required={true}
                isLarge={true}
                hasError={!doesAgree}
                checked={doesAgree}
                label={agreeLabel}
                onChange={(isChecked) => onUpdateField(isChecked)}
            />
            {!doesAgree && (
                <ErrorMessage>You must agree to the Nutshell terms and conditions.</ErrorMessage>
            )}
        </StackLegacy>
    );
}
